import { useMemo } from "react";
import PropTypes from "prop-types";

import useLanguageChange from "../../hooks/useLanguageChange";

import CenterModal from "../UI/Modal/CenterModal";

const UploadLimitReachedModal = ({ onDismissModal }) => {
    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change*/
    const localisedValues = useLanguageChange();

    const onConfirmHandler = () => {
        onDismissModal();
    };

    const header = useMemo(() => <h5 className='modal-title'>{localisedValues?.upload_limit_reached}</h5>, [localisedValues]);

    const body = useMemo(() => {
        return (
            <div className='privacy-policy-modal-text'>
                <p>{localisedValues?.uploaded_max_file}</p>
            </div>
        );
    }, [localisedValues]);

    const footer = useMemo(() => {
        return (
            <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
                <div className='button'>
                    <button className='btn default-btn-primary' onClick={() => onConfirmHandler()}>
                        {localisedValues?.dismiss}
                    </button>
                </div>
            </div>
        );
    }, [localisedValues]);

    return (
        <CenterModal
            showModal={true}
            closeModal={onDismissModal}
            modalClass='default-modal modal-small mob-bottom-top'
            className='modal-dialog-centered'
            bodyClassName='default-custom-scroll'
            header={header}
            body={body}
            footer={footer}
            keyboard={true}
            backdrop={"static"}
        />
    );
};

UploadLimitReachedModal.propTypes = {
    onDismissModal: PropTypes.func,
};

export default UploadLimitReachedModal;
